<template>
  <div class="monitoring-video-tracking-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group>
          <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置</el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15">
        <div class="item">
          <span class="span">部门</span>
          <el-select size="mini" v-model="obj.select" placeholder="请选择部门">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">工种</span>
          <el-select size="mini" v-model="obj.select11" placeholder="请选择工种">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="span">姓名</div>
          <el-input v-model="obj.txt" placeholder="请输入姓名" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">工号</div>
          <el-input v-model="obj.txt11" placeholder="请输入工号" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">识别卡</div>
          <el-input v-model="obj.txt11" placeholder="请输入识别卡" size="mini"></el-input>
        </div>
        <div class="item">
          <span class="span">起止时间</span>
          <el-date-picker size="mini" class="date-time" v-model="obj.dates"
                          type="datetimerange"
                          range-separator="到" start-placeholder="开始日期"
                          end-placeholder="结束日期"></el-date-picker>
        </div>
      </div>
    </div>

    <div class="video-tracking-box mt-15">
      <div class="left">
        <div class="left-table">
          <el-table size="mini" v-loading="tableLoading" ref="table"
                    :data="list" highlight-current-row
                    @current-change="handleCurrentChange">
            <el-table-column width="60" label="工号" property="id" align="center"></el-table-column>
            <el-table-column label="姓名">张三丰</el-table-column>
          </el-table>
        </div>
        <div class="detail">
          <div class="item" v-for="(item,index) in [1,2,3,4,5,6,6,7,8,9]" :key="index">张三丰2020-12-12 10:10:10进入1号基站
          </div>
        </div>
      </div>
      <div class="middle">
        <v-ship-map :containerHeight="500" :ship_img="ship_img"></v-ship-map>
      </div>
      <div class="right">
        <div class="video-item" v-for="(item,index) in videoList" :key="index">
          <video controls="controls" :src="item"></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false,
        videoList: ['http://wxsnsdy.tc.qq.com/105/20210/snsdyvideodownload?filekey=30280201010421301f0201690402534804102ca905ce620b1241b726bc41dcff44e00204012882540400', 'http://wxsnsdy.tc.qq.com/105/20210/snsdyvideodownload?filekey=30280201010421301f0201690402534804102ca905ce620b1241b726bc41dcff44e00204012882540400', 'http://wxsnsdy.tc.qq.com/105/20210/snsdyvideodownload?filekey=30280201010421301f0201690402534804102ca905ce620b1241b726bc41dcff44e00204012882540400']
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 3120;
      this.ship_img.height = 2164;
      this.ship_img.url = '1111';
    },

    methods: {
      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        //this.$nextTick(() => {loadingInstance.close();});
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        setTimeout(() => {
          this.tableLoading = false;
          this.pagination.total = 222;
          this.list = [
            {id: 1},
            {id: 2},
            {id: 3},
            {id: 4},
          ];
        }, 10);
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-video-tracking-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .video-tracking-box {
      width: 100%;
      min-height: 500px;
      height: auto;
      display: flex;
      .left {
        width: 200px;
        .left-table {
          height: 300px;
          overflow-y: auto;
          background: white;
        }
        .detail {
          padding: 10px;
          background: white;
          margin-top: 10px;
          height: 225px;
          overflow-y: auto;
          .item {
            font-size: 12px;
            margin-bottom: 5px;
            line-height: 20px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .middle {
        width: 0;
        height: 535px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        padding: 15px;
        flex: 1;
        margin-left: 15px;
      }
      .right {
        width: 300px;
        margin-left: 15px;
        .video-item {
          margin-bottom: 10px;
          video {
            width: 300px;
            height: 170px;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>
